import { Pipe, PipeTransform } from '@angular/core';
import format from 'date-fns/format';
import parse from 'date-fns/parse';

@Pipe({
  name: 'timeToAmPm',
})
export class TimeToAmPmPipe implements PipeTransform {
  transform(time: string): string {
    if (!time) return '';
    if (time && (time.toLowerCase().includes('pm') || time.toLowerCase().includes('pm')))
      return time;
    return format(parse(time, 'HH:mm', new Date()), 'hh:mm aaa');
  }
}
